import { createSlice } from "@reduxjs/toolkit";
import { shipmentInitialState } from "src/models/master_data/shipment/shipment.dto";
import { createMsShipmentThunk, fetchMsShipmentThunk, submitMsShipmentThunk, uploadMsShipmentThunk } from "../action/shipment.action";

export const msDistributorSlice = createSlice({
    name: 'msDistributor',
    initialState: shipmentInitialState,
    reducers: {},
    extraReducers: (builder) => {
        // Get All Shipment
        builder
            .addCase(fetchMsShipmentThunk.fulfilled, (state, action) => {
              
                state.data = action.payload.data;
                state.pagination=action.payload.pagination
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(fetchMsShipmentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(fetchMsShipmentThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Create Item
        builder
            .addCase(createMsShipmentThunk.fulfilled, (state, action) => {
                state.data.push(action.payload.data); 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(createMsShipmentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(createMsShipmentThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Upload Prices
        builder
            .addCase(uploadMsShipmentThunk.fulfilled, (state, action) => {
                state.data = action.payload.data;
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(uploadMsShipmentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(uploadMsShipmentThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

        // Submit Prices
        builder
            .addCase(submitMsShipmentThunk.fulfilled, (state, action) => {
                state.data = action.payload.data; 
                state.loading = false;
                state.error = false;
                state.errorMessage = null;
            })
            .addCase(submitMsShipmentThunk.rejected, (state, action) => {
                state.loading = false;
                state.error = true;
                state.errorMessage = action.payload as string;
            })
            .addCase(submitMsShipmentThunk.pending, (state) => {
                state.loading = true;
                state.error = false;
                state.errorMessage = null;
            });

    },
});

export default msDistributorSlice.reducer;
